import { Grade } from '../../../models/Grade';
import { Site } from '../../../models/Site';
import { TargetGroup } from '../../../models/TargetGroup';

/** A teacher or student option shown in the co-teacher / students steps. */
export interface WizardUser {
  id: string;
  firstName: string;
  lastName: string;
  gradeName?: string;
  email?: string;
}

/** Everything the create-class wizard collects across its three steps. */
export interface ClassWizardData {
  name: string;
  section: string;
  grades: Grade[];
  site: Site | null;
  coTeachers: WizardUser[];
  students: WizardUser[];
}

export const emptyWizardData: ClassWizardData = {
  name: '',
  section: '',
  grades: [],
  site: null,
  coTeachers: [],
  students: [],
};

/** Step 1 is valid (Next enabled) once the required fields are filled. */
export const isDetailsStepValid = (data: ClassWizardData): boolean =>
  Boolean(data.name.trim()) && data.grades.length > 0 && Boolean(data.site?.id);

export interface EmptyValues {
  firstName: string;
  lastName: string;
  emailAddress: string;
  grade: Grade | null;
  roadmap: TargetGroup | null;
}

export interface ErrorMessages {
  firstName: string;
  lastName: string;
  emailAddress: string;
  grade?: string | undefined;
  roadmap?: string | undefined;
  password?: string | undefined;
  role?: string | undefined;
  sites?: string | undefined;
  site?: string | undefined;
}
